<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('users.cardTitle')">
        <template slot="actions">
          <va-button icon="fa fa-plus" @click="createModal"></va-button>
        </template>
        <div class="va-card__body" v-if="users.length < 1">
          <va-notification v-if="users.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('users.noUsersFound') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card stripe="primary">
        <template class="row">
          <va-input
            class="flex xs12 lg6"
            v-model="searchValue"
            type="text"
            :placeholder="$t('users.searchPlaceholder')"
            :label="$t('users.searchLabel')"
            :disabled="users.length === 0"
          />
        </template>
        <va-list v-if="users.length > 0" fit class="mb-2">
          <va-item v-if="filteredList.length === 0">
            <va-item-section>
              {{ $t('users.noResults') }}
            </va-item-section>
          </va-item>
        </va-list>
      </va-card>
      <div class="cards-container row d-flex wrap align--start users-cards">
        <div class="flex xs12 sm6 lg4 xl3" v-for="(user, index) in filteredList" v-bind:key="user.userId">
          <va-card :key="'item' + user.userId">
            <div class="va-card__header">
              <div class="va-card__header-title" style="color: rgb(113, 186, 255);"><va-badge :color="getRoleColor(user.roles.name)">{{user.roles.name}}</va-badge></div>
              <div class="va-card__header-actions">
                <KebabMenu>
                  <div slot="buttons">
                    <va-button-group>
                      <va-button flat small color="gray" @click="toTimeline(user.userId)" icon-right="fa fa-list"></va-button>
                      <va-button flat small color="gray" @click="editModal(user, index)" icon-right="fa fa-edit"></va-button>
                      <va-button flat small color="gray" @click="changePasswordModal(user)" icon-right="fa fa-lock"></va-button>
                      <va-button flat small color="gray" :disabled="removeDisabled" @click="showPromptModal(user.userId, index)" icon-right="fa fa-trash"></va-button>
                    </va-button-group>
                  </div>
                </KebabMenu>
              </div>
            </div>
            <p><span>{{ user.name }} - {{ user.surname }}</span></p>
            <p><span>{{ user.email }}</span></p>
            <p v-if="user.event.length > 0">Location: <span class="user-location" @click="toLocation(user.event[0].eventId)">{{user.event[0].name}}</span></p>
          </va-card>
        </div>
      </div>
    </div>

    <!--    <div v-if="!this.$store.getters.isLoading" class="flex xs12">-->
    <!--      <va-card stripe="primary">-->
    <!--        <template class="row">-->
    <!--          <va-input-->
    <!--            class="flex xs12 lg6"-->
    <!--            v-model="searchValue"-->
    <!--            type="text"-->
    <!--            placeholder="Search for user by any info"-->
    <!--            label="Search"-->
    <!--            :disabled="users.length === 0"-->
    <!--          />-->
    <!--        </template>-->
    <!--        <va-list v-if="users.length > 0" fit class="mb-2">-->
    <!--          <va-item v-if="filteredList.length === 0">-->
    <!--            <va-item-section>-->
    <!--              No search results could found-->
    <!--            </va-item-section>-->
    <!--          </va-item>-->
    <!--          <div v-for="(user, index) in filteredList" v-bind:key="user.userId">-->
    <!--            <va-item :key="'item' + user.userId" clickable>-->
    <!--              <va-item-section>-->
    <!--                <va-item-label>-->
    <!--                  {{ user.name }} - {{ user.surname }}-->
    <!--                </va-item-label>-->
    <!--                <va-item-label caption>-->
    <!--                  {{ user.email }}-->
    <!--                </va-item-label>-->
    <!--              </va-item-section>-->
    <!--              <va-item-section v-if="user.event.length > 0" side>-->
    <!--                <va-badge>-->
    <!--                  {{user.event[0].name}}-->
    <!--                </va-badge>-->
    <!--              </va-item-section>-->
    <!--              <va-item-section side>-->
    <!--                <va-badge :color="getRoleColor(user.roles.name)">-->
    <!--                  {{user.roles.name}}-->
    <!--                </va-badge>-->
    <!--              </va-item-section>-->
    <!--              <va-item-section side>-->
    <!--                <va-button-group>-->
    <!--                  <va-button flat small color="gray" @click="toTimeline(user.userId)" icon-right="fa fa-list"></va-button>-->
    <!--                  <va-button flat small color="gray" @click="editModal(user, index)" icon-right="fa fa-edit"></va-button>-->
    <!--                  <va-button flat small color="gray" @click="changePasswordModal(user)" icon-right="fa fa-lock"></va-button>-->
    <!--                  <va-button flat small color="gray" :disabled="removeDisabled" @click="showPromptModal(user.userId, index)" icon-right="fa fa-trash"></va-button>-->
    <!--                </va-button-group>-->
    <!--              </va-item-section>-->
    <!--            </va-item>-->

    <!--            <va-list-separator v-if="index < users.length - 1" :key="'separator' + user.userId" />-->
    <!--          </div>-->
    <!--        </va-list>-->
    <!--      </va-card>-->
    <!--    </div>-->
    <UserCreateModal @closemodal="closeModal" :open-modal="openCreateModal" @update="afterSubmit"/>
    <va-modal
      v-model="openEditModal"
      :title="$t('users.editModalTitle')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <SwappingSquaresSpinner v-if="modalLoader"
        :animation-duration="1000"
        :size="90"
        :color="this.$store.getters.config.palette.primary"
      />
      <form v-if="!modalLoader">
        <div class="row">
          <va-input
            v-model="editUser.name"
            type="text"
            :label="$t('users.labelName')"
            :error="!!nameErrors.length"
            :error-messages="nameErrors"
            class="flex xs12"
          />
          <va-input
            v-model="editUser.surname"
            type="text"
            :label="$t('users.labelSurname')"
            :error="!!surnameErrors.length"
            :error-messages="surnameErrors"
            class="flex xs12"
          />
          <va-input
            v-model="editUser.email"
            type="email"
            :label="$t('users.labelEmail')"
            :error="!!emailErrors.length"
            :error-messages="emailErrors"
            class="flex xs12"
          />
          <va-select
            :label="$t('users.labelLocation')"
            v-model="editUser.location"
            textBy="name"
            keyBy="eventId"
            :options="locations"
            class="flex xs12"
          />
          <fieldset>
            <va-checkbox
              :label="$t('users.labelIsAdmin')"
              v-model="editUser.isAdmin"
            />
          </fieldset>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('users.btnClose') }}</va-button>
          <va-button @click.prevent="oneditsubmit()" class="my-0">{{ $t('users.btnUpdate') }}</va-button>
        </div>
      </form>
    </va-modal>
    <va-modal
      v-model="openEditPasswordModal"
      :title="$t('users.changePassModalTitle')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <SwappingSquaresSpinner v-if="modalLoader"
        :animation-duration="1000"
        :size="90"
        :color="this.$store.getters.config.palette.primary"
        style="margin: 30px auto;"
      />
      <form v-if="!modalLoader">
        <div class="row">
          <va-input
            v-model="editPassword.password"
            type="password"
            :label="$t('users.labelPassword')"
            :error="!!passwordErrors.length"
            :error-messages="passwordErrors"
            class="flex xs12"
          />
          <va-input
            v-model="editPassword.passwordAgain"
            type="password"
            :label="$t('users.labelConfirmPassword')"
            :error="!!passwordAgainErrors.length"
            :error-messages="passwordAgainErrors"
            class="flex xs12"
          />
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('users.btnClose') }}</va-button>
          <va-button @click.prevent="onepasswordsubmit()" class="my-0">{{ $t('users.btnChange') }}</va-button>
        </div>
      </form>
    </va-modal>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('users.deleteModalTitle')"
      :message="$t('users.deleteModalMessage')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('users.btnNo') }}</va-button>
        <va-button type="submit" @click="removeUser(userIdInPrompt, indexInPrompt)" class="my-0">{{ $t('users.btnYes') }}</va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import UserCreateModal from '../modals/UserCreateModal'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import KebabMenu from '@/components/menus/KebabMenu.vue'
export default {
  components: { SwappingSquaresSpinner, UserCreateModal, KebabMenu },
  mixins: [errorHandlerMixin],
  name: 'AppUsers',
  data () {
    return {
      openEditModal: false,
      openEditPasswordModal: false,
      openCreateModal: false,
      removeDisabled: false,
      users: [],
      locations: [],
      modalLoader: false,
      searchValue: '',
      password: '',
      email: '',
      name: '',
      surname: '',
      isAdmin: false,
      location: {},
      editUser: {
        index: '',
        userId: '',
        email: '',
        name: '',
        surname: '',
        location: {},
        isAdmin: false,
      },
      editPassword: {
        userId: '',
        password: '',
        passwordAgain: '',
      },
      emailErrors: [],
      passwordErrors: [],
      passwordAgainErrors: [],
      nameErrors: [],
      surnameErrors: [],
      showRemoveModal: false,
      indexInPrompt: null,
      userIdInPrompt: null,
    }
  },
  methods: {
    async createModal () {
      this.openCreateModal = true
    },
    async closeModal (state) {
      this.openCreateModal = state
    },
    async editModal (user, index) {
      await this.getTheLocations()
      let location = {}
      if (user.event.length > 0) {
        location = this.locations.filter(function (item) {
          return item.eventId === user.event[0].eventId
        })
        location = location[0]
      }
      this.editUser.index = index
      this.editUser.userId = user.userId
      this.editUser.email = user.email
      this.editUser.name = user.name
      this.editUser.surname = user.surname
      this.editUser.isAdmin = user.roles.name === 'Administrator'
      this.editUser.location = location
      this.openEditModal = true
    },
    showPromptModal (userId, index) {
      this.userIdInPrompt = userId
      this.indexInPrompt = index
      this.showRemoveModal = true
    },
    changePasswordModal (user) {
      this.editPassword.userId = user.userId
      this.openEditPasswordModal = true
    },
    disableModal () {
      this.openCreateModal = false
      this.openEditModal = false
      this.openEditPasswordModal = false
      this.password = ''
      this.email = ''
      this.name = ''
      this.surname = ''
      this.isAdmin = false
      this.location = {}
      this.editUser.index = ''
      this.editUser.userId = ''
      this.editUser.email = ''
      this.editUser.name = ''
      this.editUser.surname = ''
      this.editUser.isAdmin = false
      this.editUser.location = {}
      this.editPassword.userId = ''
      this.editPassword.password = ''
      this.editPassword.passwordAgain = ''
      this.modalLoader = false
      this.emailErrors = []
      this.passwordErrors = []
      this.passwordAgainErrors = []
      this.nameErrors = []
      this.surnameErrors = []
      this.removeDisabled = false
    },
    oneditsubmit () {
      this.emailErrors = this.editUser.email ? [] : [this.$t('users.requiredEmail')]
      this.nameErrors = this.editUser.name ? [] : [this.$t('users.requiredName')]
      this.surnameErrors = this.editUser.surname ? [] : [this.$t('users.requiredSurname')]
      if (!this.formUserEditSubmitReady) {
        return
      }
      this.modalLoader = true
      const payload = {
        message: {
          email: this.editUser.email,
          name: this.editUser.name,
          surname: this.editUser.surname,
          isAdmin: this.editUser.isAdmin,
          eventId: this.editUser.location.eventId,
        },
        userId: this.editUser.userId,
      }
      this.$store.dispatch('appUserUpdate', payload)
        .then((resp) => this.afterEditSubmit(resp.data.message, this.editUser.index))
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    onepasswordsubmit () {
      this.passwordErrors = this.editPassword.password ? [] : [this.$t('users.requiredPassword')]
      this.passwordAgainErrors = this.editPassword.passwordAgain ? [] : [this.$t('users.requiredConfirmPassword')]
      this.passwordErrors = this.editPassword.password === this.editPassword.passwordAgain ? [] : [this.$t('users.requiredSamePassword')]
      if (!this.formUserEditPasswordSubmitReady) {
        return
      }
      this.modalLoader = true
      const payload = {
        message: {
          password: this.editPassword.password,
        },
        userId: this.editPassword.userId,
      }
      this.$store.dispatch('appUserPasswordUpdate', payload)
        .then(() => this.disableModal())
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    removeUser (userId, index) {
      this.removeDisabled = true
      this.$store.dispatch('appUserDelete', userId)
        .then(() => {
          this.users.splice(index, 1)
          this.showRemoveModal = false
        })
        .then(() => this.disableModal())
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
          this.showRemoveModal = false
        })
    },
    afterSubmit (user) {
      this.users.splice(this.users.length, -1, user)
      this.disableModal()
    },
    afterEditSubmit (user, index) {
      this.users.splice(index, 1, user)
      this.disableModal()
    },
    getRoleColor (status) {
      if (status === 'Administrator') {
        return 'success'
      }
      return 'danger'
    },
    async getTheLocations () {
      await this.$store.dispatch('getLocations')
        .then(resp => this.initlocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
      // if (this.$store.getters.locations.length === 0) {
      //   await this.$store.dispatch('getLocations')
      //     .then(resp => this.initlocations()).catch(error => this.errorHandler(error.response))
      // } else {
      //   this.locations = this.$store.getters.locations
      // }
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
    async toTimeline (userId) {
      await this.$router.push({
        name: 'app-user-timeline',
        params: { userId: userId },
      })
    },
    async initUsers (users) {
      this.users.splice(0, this.users.length, ...users)
      this.$store.commit('setLoading', false)
    },
    async toLocation (locationId) {
      await this.$router.push({
        name: 'location',
        params: { locationId: locationId },
      })
    },
  },
  computed: {
    formUserSubmitReady () {
      return !(this.emailErrors.length || this.surnameErrors.length || this.nameErrors.length || this.passwordErrors.length)
    },
    formUserEditSubmitReady () {
      return !(this.emailErrors.length || this.surnameErrors.length || this.nameErrors.length)
    },
    formUserEditPasswordSubmitReady () {
      return !(this.passwordErrors.length || this.passwordAgainErrors.length)
    },
    filteredList () {
      const value = this.searchValue.charAt(0).toLowerCase() + this.searchValue.slice(1)
      return this.users.filter((user) => {
        return (user.name && user.name.toLowerCase().includes(value)) ||
          (user.surname && user.surname.toLowerCase().includes(value)) ||
          (user.email && user.email.toLowerCase().includes(value))
      })
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('appUserList')
      .then((resp) => this.initUsers(resp.data.message))
      .catch(error => {
        this.errorHandler(error.response)
        this.modalLoader = false
      })
  },
}
</script>

<style lang="scss">
  .users-cards {
    .va-card {
      &__header {
        display: flex;
        align-items: center;

        &-title {
          font-size: 1rem;
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        &-actions {
          display: flex;
        }
      }

      &__body {
        overflow: visible;

        .va-button--small.va-button--with-right-icon {
          padding-right: 0.75rem;
        }

        p {
          font-size: 14px;
        }

        .user-location {
          color: rgb(113, 186, 255);

          &:hover {
            cursor: pointer;
          }
        }

        .flex-checkbox {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .markup-tables {
    .va-table {
      width: 100%;
    }

    .va-card {
      max-width: 1200px;
    }
  }

  .va-item {
    cursor: default !important;
    min-width: 725px;
  }
</style>
